import React from 'react'
import IndexPage from '../index-table/IndexPage'
import APIServicesRegistry from '@lib/api-services/APIServicesRegistry';
import ProjectAPIService from '@lib/api-services/ProjectApiService';
import ProjectsAPIService from '@lib/api-services/ProjectsApiService';
import ProjectsTable from '../projects/ProjectsTable'
import GroupedProjectsTable from './GroupedProjectsTable';
import IconCheck from '../icons/IconCheck';
import ProjectsIndexTableFiltersPanel from './ProjectsIndexTableFiltersPanel';

class ProjectIndexPage extends IndexPage {
    static defaultProps = {
        filterPanelComponentClass: ProjectsIndexTableFiltersPanel
    }

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            isGroupingActive: false,
            filterData: {
                filter: {
                    show: false
                }
            }
        };
    }

    atDocumentReady = () => {
        this.indexApiService = APIServicesRegistry.getService(ProjectsAPIService);
        this.editApiService = APIServicesRegistry.getService(ProjectAPIService);

        if (this._isMounted) {
            this.setState({renderTrigger: Math.random()})
        }
    }

    onRemoveClick() {
        var ids = []
        for (let [k, v] of Object.entries(this.state.manuallyChangedRows)) {
            if (v) {
                ids.push(parseInt(k))
            }
        }

        this.setState({isLoading: true})
        this.editApiService.deleteBatch(ids).then(() => {
            var filtered = this.state.results.filter(x => !ids.includes(x.id))
            this.setState({
                results: filtered,
                deleteModalIsOpen: false,
                isLoading: false,
                isGroupingActive: false
            })
        })
    }

    onGroupButtonClick = () => {
        this.setState({
            isGroupingActive: !this.state.isGroupingActive
        }, () => {
            this.filterRef.current.callOnFiltersChange();
        });
    }

    renderTitle = () => {
        return (
            <React.Fragment>
                <h3 className="page-body-title">{__('Projects')}</h3>
                <div className="page-body-title-separator"></div>
            </React.Fragment>
        )
    }

    renderGroupButton = () => {
        return (
            <div className="index-table-group-button-container">
                <div className={`index-table-group-button ${this.state.isGroupingActive ? 'active' : ''}`}
                     onClick={this.onGroupButtonClick}>
                    <span> 
                        <span className="icon-container">
                            {this.state.isGroupingActive && (
                                <IconCheck size={IconCheck.Size.Default}/>
                            )}
                        </span>
                    </span>

                    <span>{__('Group by project')}</span>
                </div>
            </div>
        )
    }

    getFilterDataForGroupButton = () => {
        return {
            groupByProject: this.state.isGroupingActive
        }
    }

    renderTable = () => {
        const commonProps = {
            results: this.state.results,
            options: this.props.options,
            orderOptions: this.props.orderOptions,
            onSortChange: this.onSortChange,
            onRemoveRowClick: this.onRemoveRowClick,
            onRootCheckboxToggled: this.onRootCheckboxToggled,
            onRowCheckboxToggled: this.onRowCheckboxToggled,
            multiSelectRows: this.props.multiSelectRows,
            onReloadCall: this.onReloadCall
        };

        if (this.state.isGroupingActive) {
            const columns = Array.from(this.props.columns);
            columns.splice(0, 0, {name: '', slug: 'Expander'});

            return (
                <GroupedProjectsTable
                    {...commonProps}
                    columns={columns}
                />
            );
        }

        return (
            <ProjectsTable
                {...commonProps}
                columns={this.props.columns}
            />
        );
    }
}

window.components.ProjectIndexPage = ProjectIndexPage